import { base, type IIconProps } from './base';

export function PortfolioIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  );
}

export function DashboardIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 12a9 9 0 1 1 18 0" />
      <path d="M12 12l4-2" />
      <circle cx="12" cy="12" r="1.4" fill="currentColor" />
    </svg>
  );
}

export function AiAgentIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M12 3l2.4 3.2L18 7l-2 3 2 3-3.6.8L12 17l-2.4-3.2L6 13l2-3-2-3 3.6-.8z" />
    </svg>
  );
}

export function SchedulerIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="3" y="5" width="18" height="16" rx="1.5" />
      <path d="M3 10h18" />
      <path d="M8 3v4M16 3v4" />
    </svg>
  );
}

export function CadIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 7l9-4 9 4-9 4-9-4z" />
      <path d="M3 12l9 4 9-4" />
      <path d="M3 17l9 4 9-4" />
    </svg>
  );
}

export function DocumentIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
      <path d="M14 2v4a2 2 0 0 0 2 2h4" />
      <path d="M10 9H8" />
      <path d="M16 13H8" />
      <path d="M16 17H8" />
    </svg>
  );
}

export function DocumentsIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M6 3h8l4 4v14H6z" />
      <path d="M14 3v4h4" />
      <path d="M9 13h6M9 17h6" />
    </svg>
  );
}

export function LogisticsIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 7h10v10H3z" />
      <path d="M13 10h5l3 3v4h-8z" />
      <circle cx="7" cy="18" r="1.8" />
      <circle cx="17" cy="18" r="1.8" />
    </svg>
  );
}

export function AdminIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19 12a7 7 0 0 0-.1-1.2l2-1.5-2-3.4-2.3.9a7 7 0 0 0-2-1.2L14 3h-4l-.6 2.6a7 7 0 0 0-2 1.2L5 5.9l-2 3.4 2 1.5a7 7 0 0 0 0 2.4l-2 1.5 2 3.4 2.3-.9a7 7 0 0 0 2 1.2L10 21h4l.6-2.6a7 7 0 0 0 2-1.2l2.3.9 2-3.4-2-1.5A7 7 0 0 0 19 12z" />
    </svg>
  );
}

export function SearchIcon({ size = 14 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="7" />
      <path d="M20 20l-4.3-4.3" />
    </svg>
  );
}

export function Building2Icon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
      <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
      <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
      <path d="M10 6h4M10 10h4M10 14h4M10 18h4" />
    </svg>
  );
}

export function BuildingIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 21V5a2 2 0 0 1 2-2h7v18" />
      <path d="M13 9h5a2 2 0 0 1 2 2v10" />
      <path d="M8 7h1M8 11h1M8 15h1M16 13h1M16 17h1" />
    </svg>
  );
}

export function HandshakeIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="m11 17 2 2a1 1 0 1 0 3-3" />
      <path d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4" />
      <path d="m21 3 1 11h-2" />
      <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3" />
      <path d="M3 4h8" />
    </svg>
  );
}

export function TrendingIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <polyline points="3 17 9 11 13 15 21 7" />
      <polyline points="14 7 21 7 21 14" />
    </svg>
  );
}

interface IUsersIconProps extends IIconProps {
  /** className forwarded to the <svg> element for targeted CSS. */
  className?: string;
  /** Override the shared 1.6 stroke — e.g. the Gantt crew chips render at 2.2
      so the glyph stays legible at 10px. */
  strokeWidth?: number;
}

export function UsersIcon({ size = 20, className, strokeWidth = base.strokeWidth }: IUsersIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base} strokeWidth={strokeWidth} className={className}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

export function ShieldIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M12 2l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V6l8-4z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}

export function EmptyShieldIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>
    </svg>
  )
}

export function AlertIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );
}

export function BellIcon({ size = 18 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round">
      <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9z" />
      <path d="M10 21a2 2 0 0 0 4 0" />
    </svg>
  );
}

export function IssuesIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="6" y="4" width="12" height="17" rx="2" />
      <rect x="9" y="2" width="6" height="3" rx="1" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}

export function MonitorIcon({ size = 20 }: IIconProps) { 
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="2" y="3" width="20" height="14" rx="2"/>
      <line x1="12" y1="17" x2="12" y2="21"/>
      <line x1="8" y1="21" x2="16" y2="21"/>
    </svg>
  )
}

export function CpuIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="4" y="4" width="16" height="16" rx="2"/>
      <rect x="9" y="9" width="6" height="6" rx="1"/>
      <path d="M15 2v2"/>
      <path d="M15 20v2"/>
      <path d="M2 15h2"/>
      <path d="M2 9h2"/>
      <path d="M20 15h2"/>
      <path d="M20 9h2"/>
      <path d="M9 2v2"/>
      <path d="M9 20v2"/>
    </svg>
  )
}

export function PeakIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="m8 3 4 8 5-5 5 15H2L8 3z"/>
    </svg>
  )
}

export function CalendarIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M8 2v4"/>
      <path d="M16 2v4"/>
      <rect x="3" y="4" width="18" height="18" rx="2"/>
      <path d="M3 10h18"/>
      <path d="M8 14h.01"/>
      <path d="M12 14h.01"/>
      <path d="M16 14h.01"/>
      <path d="M8 18h.01"/>
      <path d="M12 18h.01"/>
      <path d="M16 18h.01"/>
    </svg>
  )
}

export function ListIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 6h.01"/>
      <path d="M3 12h.01"/>
      <path d="M3 18h.01"/>
      <path d="M8 6h13"/>
      <path d="M8 12h13"/>
      <path d="M8 18h13"/>
    </svg>
  )
}

export function GridIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="3" y="3" width="18" height="18" rx="2"/>
      <path d="M3 9h18"/>
      <path d="M3 15h18"/>
      <path d="M9 3v18"/>
      <path d="M15 3v18"/>
    </svg>
  )
}

export function ChartColumnIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M3 3v16a2 2 0 0 0 2 2h16"/>
      <path d="M18 17V9"/>
      <path d="M13 17V5"/>
      <path d="M8 17v-3"/>
    </svg>
  )
}

export function ActivityIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2"/>
    </svg>
  )
}

export function FileStackIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M21 7h-3a2 2 0 0 1-2-2V2"/>
      <path d="M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z"/>
      <path d="M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15"/>
      <path d="M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11"/>
    </svg>
  )
}

export function GaugeIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="m12 14 4-4"/>
      <path d="M3.34 19a10 10 0 1 1 17.32 0"/>
    </svg>
  )
}

export function HardHatIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5"/>
      <path d="M14 6a6 6 0 0 1 6 6v3"/>
      <path d="M4 15v-3a6 6 0 0 1 6-6"/>
      <rect x="2" y="15" width="20" height="4" rx="1"/>
    </svg>
  )
}

export function ChartPieIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z"/>
      <path d="M21.21 15.89A10 10 0 1 1 8 2.83"/>
    </svg>
  )
}

export function DollarSignIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <line x1="12" y1="2" x2="12" y2="22"/>
      <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
    </svg>
  )
}

export function BriefcaseIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"/>
      <rect x="2" y="6" width="20" height="14" rx="2"/>
    </svg>
  )
}

export function SparklesIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
      <path d="M20 3v4"/>
      <path d="M22 5h-4"/>
      <path d="M4 17v2"/>
      <path d="M5 18H3"/>
    </svg>
  )
}

export function WorkflowIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <rect x="3" y="3" width="8" height="8" rx="2"/>
      <path d="M7 11v4a2 2 0 0 0 2 2h4"/>
      <rect x="13" y="13" width="8" height="8" rx="2"/>
    </svg>
  )
}

export function CompassIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"/>
      <circle cx="12" cy="12" r="10"/>
    </svg>
  )
}

// Help (question-mark circle), from trusstor_dashboard's sideBar/helpIcon.svg.
// Filled glyph, so it opts out of `base` (stroke-only) like ZapIcon does.
export function HelpCircleIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="4 4 24 24" fill="currentColor" aria-hidden="true">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.33325 16.0007C7.33325 11.2142 11.2135 7.33398 15.9999 7.33398C20.7864 7.33398 24.6666 11.2142 24.6666 16.0007C24.6666 20.7871 20.7864 24.6673 15.9999 24.6673C11.2135 24.6673 7.33325 20.7871 7.33325 16.0007ZM15.9999 5.33398C10.1089 5.33398 5.33325 10.1096 5.33325 16.0007C5.33325 21.8917 10.1089 26.6673 15.9999 26.6673C21.891 26.6673 26.6666 21.8917 26.6666 16.0007C26.6666 10.1096 21.891 5.33398 15.9999 5.33398ZM13.9946 13.4397L13.9933 13.4492L13.9932 13.4496C13.9297 13.9958 13.4367 14.3887 12.8895 14.3279C12.3406 14.2669 11.9451 13.7725 12.006 13.2236L12.9999 13.334C12.006 13.2236 12.0061 13.2231 12.0061 13.2227L12.0062 13.2217L12.0065 13.2196L12.0071 13.2145L12.0087 13.2009C12.0101 13.1904 12.0118 13.177 12.0141 13.1609C12.0186 13.1288 12.0252 13.0856 12.0344 13.0331C12.0527 12.9283 12.0816 12.7844 12.1257 12.6143C12.2129 12.278 12.3648 11.8181 12.6258 11.3483C13.16 10.3867 14.1967 9.33398 15.9999 9.33398C17.554 9.33398 18.6568 9.83321 19.3137 10.7527C19.9206 11.6025 19.9999 12.6225 19.9999 13.334C19.9999 14.7156 19.2115 16.1097 17.6668 16.7066C17.4395 16.7944 17.2527 16.9211 17.1355 17.05C17.0246 17.1719 16.9999 17.2651 16.9999 17.334V17.6673C16.9999 18.2196 16.5522 18.6673 15.9999 18.6673C15.4476 18.6673 14.9999 18.2196 14.9999 17.6673V17.334C14.9999 15.986 16.0998 15.168 16.9459 14.841C17.6593 14.5654 17.9999 13.956 17.9999 13.334C17.9999 12.7121 17.9125 12.2321 17.6862 11.9152C17.5097 11.6681 17.1125 11.334 15.9999 11.334C15.1365 11.334 14.6732 11.7813 14.3741 12.3196C14.2184 12.5998 14.1203 12.89 14.0617 13.1162C14.0329 13.2273 14.0149 13.3178 14.0046 13.3771C13.9994 13.4066 13.9962 13.4279 13.9946 13.4397ZM15.9999 21.6673C16.184 21.6673 16.3333 21.5181 16.3333 21.334C16.3333 21.1499 16.184 21.0007 15.9999 21.0007C15.8158 21.0007 15.6666 21.1499 15.6666 21.334C15.6666 21.5181 15.8158 21.6673 15.9999 21.6673ZM14.3333 21.334C14.3333 20.4135 15.0795 19.6673 15.9999 19.6673C16.9204 19.6673 17.6666 20.4135 17.6666 21.334C17.6666 22.2545 16.9204 23.0007 15.9999 23.0007C15.0795 23.0007 14.3333 22.2545 14.3333 21.334Z" />
    </svg>
  );
}

export function BookOpenIcon({ size = 20 }: IIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" {...base}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20V3H6.5A2.5 2.5 0 0 0 4 5.5z" />
      <path d="M4 19.5V21h16" />
    </svg>
  );
}
